<template>
  <div class="footer" ref="footer" v-if="threadState != 'closed'" :class="{ 'has_cart_share': shareCartAvailable }">
    <div tabindex="0" class="more-container" v-if="this.moreActive">
      <div class="option-footer" @click="filesActive">
        <button tabindex="0" :title="$gettext('Adjuntar archivo')" class="action-icon paperclip"></button>
        <p>{{ $gettext("Adjuntar archivo") }}</p>
      </div>
      <div v-if="shareCartAvailable" class="option-footer" @click="shareCart">
        <button tabindex="0" :title="$gettext('Compartir carrito')" class="action-icon cart"></button>
        <p>{{ $gettext("Compartir carrito") }} </p>
      </div>
    </div>
    <div class="inputs">
      <div class="inputs__text" :class="{ 'borderMaxCharacters': maxCharacters === 200 }">
        <button 
            tabindex="0" 
            :title="$gettext('Más opciones')"
            class="action-icon more" 
            v-if="shareCartAvailable" 
            @click="handleMore">
        </button>
        <button 
            tabindex="0" 
            :title="$gettext('Adjuntar archivo')"
            class="action-icon only-paperclip" 
            v-else 
            @keyup.enter="toggleFiles" 
            @click="toggleFiles">
        </button>

        <emoji-picker v-if="!isMobile()" class="emoji__container" @emoji="insert" :search="search">
          <button 
              class="emoji-invoker" 
              slot="emoji-invoker" 
              slot-scope="{ events: { click: clickEvent } }"
              :title="$gettext('Abrir selector de emojis')"
              @click.stop="clickEvent">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current text-grey">
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                  d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
            </svg>
          </button>
          <div class="emojis__pckt" slot="emoji-picker" slot-scope="{ emojis, insert, display }">
            <div class="emoji-picker" :style="{ top: 'auto', bottom: '3rem', left: '3rem', right: '0' }">
               <div class="emoji-picker__search">
                <input type="text" v-model="search" v-focus :title="$gettext('Buscar emoji')" :placeholder="$gettext('Buscar emoji')">
              </div>
              <div>
                <div class="emojisGroup" v-for="(emojiGroup, category) in emojis" :key="category">
                  <h5>{{ category }}</h5>
                  <div class="emojis">
                    <span tabindex="0" 
                          v-for="(emoji, emojiName) in emojiGroup" 
                          :key="emojiName" 
                          @click="insert(emoji)"
                          @keyup.enter="insert(emoji)"
                          :title="emojiName">{{ emoji }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </emoji-picker>
          <textarea
              maxlength="200"
              :placeholder="$gettext('Escribe aquí')"
              v-model="message"
              :title="$gettext('Campo de texto para escribir mensaje')"
              @input="handleInput"
              @keyup.enter="getMessage"
              @keydown.enter.prevent="enterKeyDown" />
      </div>
      <div 
          aria-live="assertive" 
          tabindex="-1"
          class="alertMaxCharacters" 
          v-if="maxCharacters === 200">
              {{ $gettext('Has alcanzado el limite de caracteres')}}
      </div>
      <div
          aria-live="assertive"
          tabindex="-1"
          :class="['alertWrongCharacters', this.wrongCharacters ? 'show' : 'hide']">
              {{ $gettext('Solo se permiten letras y números')}}
      </div>
      <div
          aria-live="assertive"
          tabindex="-1"
          :class="['alertWrongCharacters', this.moderationError ? 'show' : 'hide']">
              {{ $gettext('No podemos enviar este mensaje.')}}
      </div>
      <button tabindex="0"
            class="action-icon send"
            :class="{'disabled' : this.message.trim(' ').length === 0 || this.isModerating}"
            :disabled="this.message.trim(' ').length === 0 || this.isModerating"
            :style="config ? { backgroundColor: config.background_color  + ' !important' }: {}" 
            :title="$gettext('Enviar mensaje')"
            @click="getMessage"
            @keyup.enter="getMessage">
        </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';


import axios from 'axios';
import EmojiPicker from 'vue-emoji-picker'

const MODERATION_KEYWORDS = [
  // --- Hacking / intrusion ---
  'hack',                  // hackear, hackeado, hacker, hackeo…
  'sistema intervenid',    // intervenido/a
  'acceso concedid',       // concedido/a
  'he tomado control',
  'sistema comprometid',   // comprometido/a
  'system breach',         // breached
  'system compromis',      // compromised
  'access granted',

  // --- Threats / violence ---
  'amenaz',                // amenaza, amenazar, amenazas, amenazarte…
  'te voy a matar',
  'os voy a matar',
  'voy a ir a por ti',
  'hacerte daño',
  'me las vas a pagar',
  'i will kill',
  'i will find you',
  'you will pay',
  'i am going to hurt',

  // --- Insults (Spanish) ---
  'imbécil', 'imbecil',    // imbécil, imbéciles
  'subnormal',             // subnormal, subnormales
  'gilipollas',
  'cabrón', 'cabron',      // cabrón, cabrones, cabrona…
  'capullo',
  'jódete', 'jodete',
  'vete a la mierda',
  'me cago en',
  'hijo de puta',
  'que os den',
  'puta mierda',
  'sois una mierda',
  'inútil', 'inutil',      // inútil, inútiles

  // --- Insults (English) ---
  'fuck',                  // fuck, fucking, fucker, fucked…
  'son of a bitch',
  'piece of shit',
  'asshole',
  'go to hell',
  'you suck',
  'moron',                 // moron, morons, moronic
  'idiot',                 // idiot, idiots, idiotic
  'scammer',

  // --- Social engineering / prompt injection ---
  'ignora las instrucciones',
  'olvida lo anterior',
  'actúa como', 'actua como',
  'nuevo modo',
  'modo desarrollador',
  'sin restricciones',
  'ignore previous',       // ignore previous instructions…
  'disregard your',        // disregard your instructions…
  'you are now',
  'developer mode',
  'jailbreak',
  'dan mode',
  'pretend you are',
  'forget your rules',
  'prompt inject',
];

// Word-boundary (\b) match so keywords only hit at word start: avoids mid-word
// false positives while keeping conjugations (hack -> hackear). 'i' = case-insensitive.
const MODERATION_REGEX = new RegExp(
  '\\b(' +
    MODERATION_KEYWORDS
      .map(kw => kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|') +
  ')',
  'i'
);

export default {
  name: 'ChatFooter',
  components: {
    EmojiPicker
  },
  data() {
    return {
      message: '',
      maxCharacters: 0,
      wrongCharacters: false,
      moderationError: false,
      isModerating: false,
      search: '',
      localMessage: this.message,
      isDisabled: false,
      moreActive: false
    }
  },
  mounted() {
    window.chatFooter = this; // Registrar instancia en el objeto global
  },
  methods: {
    ...mapActions(['sendUserMessage', 'closeCurrentChat', 'shareCartWithAgent', 'updateDrag']),
    ...mapMutations(['updateDrag']),
    async getMessage(event) {
      if (event.shiftKey === true && event.key === "Enter") {
        return;
      }

      const text = this.message.trim();
      if (text.length === 0) return;

      // Phase A: instant keyword check (word-boundary, see MODERATION_REGEX)
      if (MODERATION_REGEX.test(text)) {
        this.showModerationError();
        return;
      }

      // --- Phase B: LLM check via backend disabled ---
      // this.isModerating = true;
      // try {
      //   const params = new URLSearchParams();
      //   params.append('message', text);
      //   params.append('thread', this.$store.state.id);
      //   params.append('token', this.$store.state.token);
      //   const response = await axios.post(
      //     process.env.VUE_APP_PWS_BASE_URL + 'moderation_check.php',
      //     params
      //   );
      //   if (response.data.verdict === 'joke' || response.data.verdict === 'threat') {
      //     this.showModerationError();
      //     return;
      //   }
      // } catch (_) {
      //   // fail-open: allow the message through if moderation is unavailable
      // } finally {
      //   this.isModerating = false;
      // }

      this.sendUserMessage(this.message);
      this.message = "";
    },
    showModerationError() {
      this.moderationError = true;
      setTimeout(() => { this.moderationError = false; }, 5000);
    },
    enterKeyDown(event) {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
      }
    },
    shareCart() {
      this.shareCartWithAgent(this.cartInfo);
    },
    insert(emoji) {
      this.message += emoji
    },

    filesActive(event) {
      event.preventDefault();
      this.updateDrag(true)

      this.moreActive = false;
    },
    handleMore() {
      this.moreActive = !this.moreActive;
    },
    toggleFiles(event) {
      event.preventDefault();
      if (this.dragActive == false) {
        this.updateDrag(true)
      } else if (this.dragActive == true) {
        this.updateDrag(false)
      }
    },
    showWrongCharacters() {
      this.wrongCharacters = true;
      setTimeout(() => {
        this.wrongCharacters = false;
      }, 5000);
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    handleInput(event) {
      // Force reactivity update for mobile keyboards
      this.$forceUpdate();
    },

  },
  watch: {
    message(newValue) {
      if (newValue.length <= 200) {
        this.maxCharacters = newValue.length;
        this.localMessage = newValue;
      }
    }
  },
  computed: {
    ...mapGetters(['shareCartAvailable', 'config', 'cartInfo', 'threadState']),
    ...mapState(['dragActive']),
  }
}
</script>
